import * as React from 'react';
export var buildClassnames = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    return classNames.filter(function (val) { return val; }).join(' ');
};
export var HeaderRegion = function (props) {
    var classes = buildClassnames('header-region', props.className);
    return React.createElement("div", { className: classes }, props.children);
};
//# sourceMappingURL=header-region.js.map